// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__A1MvK","title":"FrontImage_title__3laW3"};